// import React, { useEffect, useState, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table';
// import { useTranslation } from 'react-i18next';
// import { api_url } from '../../constant/constant';

// const CampaignEmailLog = ({ id }) => {
//   const [emailLogs, setEmailLogs] = useState([]);
//   const [filteredLogs, setFilteredLogs] = useState([]);
//   const [links, setLinks] = useState([]);
//   const [searchValue, setSearchValue] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   // Fetch email logs with optional URL (for pagination)
//   const fetchEmailLogs = async (url = null) => {
//     setLoading(true);
//     setError('');
//     try {
//       const token = localStorage.getItem('userToken');
//       const fetchUrl = url || `${api_url}/compliance-campaigns/${id}/email-logs`;
//       const response = await fetch(fetchUrl, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json();

//       // result.data.data contains the email logs array
//       setEmailLogs(result.data.data || []);
//       setFilteredLogs(result.data.data || []);
//       setLinks(result.data.links || []);
//     } catch (err) {
//       console.error('Error fetching email logs:', err);
//       setError(t('errorFetchingEmailLogs'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Load data on component mount or id change
//   useEffect(() => {
//     fetchEmailLogs();
//   }, [id]);

//    useEffect(() => {
//           if (searchValue !== '') {
//               const filteredData = emailLogs.filter((item) =>
//                   item.email.toLowerCase().includes(searchValue.toLowerCase())
//                   || item.username.toLowerCase().includes(searchValue.toLowerCase())
//                   || item.firstname.toLowerCase().includes(searchValue.toLowerCase())
//                   || item.lastname.toLowerCase().includes(searchValue.toLowerCase())
//               );
//               setEmailLogs(filteredData);
//           } else {
//             fetchEmailLogs(''); // Fetch data on page load
//           }
//       }, [searchValue]);

//   // Filter emailLogs based on searchValue
//   useEffect(() => {
//     if (!searchValue) {
//       setFilteredLogs(emailLogs);
//     } else {
//       const filtered = emailLogs.filter((item) =>
//         (item.email || '').toLowerCase().includes(searchValue.toLowerCase())
//       );
//       setFilteredLogs(filtered);
//     }
//   }, [searchValue, emailLogs]);

//   // Define columns for react-table
//   const columns = useMemo(
//     () => [
//       {
//         accessorKey: 'email',
//         header: () => (
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//             <i className="bi bi-envelope"></i> {t('Email')}
//           </div>
//         ),
//         colName: t('Email'),
//       },
//       {
//         accessorKey: 'status',
//         header: () => (
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//             <i className="bi bi-check-circle"></i> {t('Status')}
//           </div>
//         ),
//         colName: t('Status'),
//       },
//       {
//         accessorKey: 'created_at',
//         header: () => (
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//             <i className="bi bi-calendar"></i> {t('CreatedAt')}
//           </div>
//         ),
//         colName: t('CreatedAt'),
//         cell: ({ getValue }) => {
//           const date = new Date(getValue());
//           return date.toLocaleString();
//         },
//       },
//     ],
//     [t]
//   );

//   // Initialize react-table instance
//   const table = useReactTable({
//     data: filteredLogs,
//     columns,
//     getCoreRowModel: getCoreRowModel(),
//   });

//   return (
//     <div className="p-4 mb-4">
//       <div className="primaryBlueBox mb-4" id="pa">
//         <div className="row">
//           <div className="col-md-4">
//             <label className="form-label">{t('SearchEmailLogs')}</label>
//             <div className="input-group">
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder={t("Searchbyusername")}
//                 aria-label="Search by name"
//                 value={searchValue}
//                 onChange={(e) => setSearchValue(e.target.value)}
//               />
//               <button className="btn btn-outline-secondary btnSearchIcon" type="button">
//                 <i className="bi bi-search"></i>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {error && (
//         <div className="alert alert-danger" role="alert">
//           {error}
//         </div>
//       )}

// <h3>{t('CampaignEmailLog')}</h3>

//       {loading ? (
//         <div className="d-flex justify-content-center align-items-center mt-5">
//           <div
//             className="spinner-border loader-api"
//             role="status"
//             style={{
//               borderTopColor: '#6897CB',
//               borderBottomColor: '#6897CB',
//               borderLeftColor: '#6897CB',
//               marginTop: '50px',
//             }}
//           />
//         </div>
//       ) : filteredLogs.length === 0 ? (
//         <div className="text-center mt-4">{t('NoRecordsFound')}</div>
//       ) : (
//         <>
//           {window.innerWidth < 768 ? (
//             // Small screen stacked view
//             <div className="stacked-table">
//               {table.getRowModel().rows.map((row) => (
//                 <div key={row.id} className="stacked-row border p-2 mb-2 rounded">
//                   {row.getVisibleCells().map((cell) => (
//                     <div key={cell.id} className="stacked-cell">
//                       <strong>{cell.column.columnDef.colName}: </strong>
//                       {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           ) : (
//             // Desktop table view
//             <table className="table table-bordered table-hover">
//               <thead className="thead-dark">
//                 {table.getHeaderGroups().map((headerGroup) => (
//                   <tr key={headerGroup.id}>
//                     {headerGroup.headers.map((header) => (
//                       <th key={header.id}>
//                         {flexRender(header.column.columnDef.header, header.getContext())}
//                       </th>
//                     ))}
//                   </tr>
//                 ))}
//               </thead>
//               <tbody>
//                 {table.getRowModel().rows.map((row) => (
//                   <tr key={row.id}>
//                     {row.getVisibleCells().map((cell) => (
//                       <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}

// <div className="navigationWrapper">
//         <ul>
//           {links.map((link, index) => (
//             <li
//               key={index}
//               className={`${link.active ? 'active' : ''} ${link.url === null ? 'disabled' : ''
//                 }`}
//               onClick={link.url !== null ? () => fetchEmailLogs(link.url) : undefined}
//             >
//               <div dangerouslySetInnerHTML={{ __html: link.label }} />
//             </li>
//           ))}
//         </ul>
//       </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default CampaignEmailLog;

import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { api_url } from "../../constant/constant";

const CampaignEmailLog = ({ id }) => {
  const [emailLogs, setEmailLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [links, setLinks] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Fetch email logs with optional URL (for pagination)
  const fetchEmailLogs = async (url = null) => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem("userToken");
      const fetchUrl =
        url || `${api_url}/compliance-campaigns/${id}/email-logs`;
      const response = await fetch(fetchUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      // result.data.data contains the email logs array
      setEmailLogs(result.data.data || []);
      setFilteredLogs(result.data.data || []);
      setLinks(result.data.links || []);
    } catch (err) {
      console.error("Error fetching email logs:", err);
      setError(t("errorFetchingEmailLogs"));
    } finally {
      setLoading(false);
    }
  };

  // Load data on component mount or id change
  useEffect(() => {
    fetchEmailLogs();
  }, [id]);

  // Filter emailLogs based on searchValue
  useEffect(() => {
    if (searchValue !== "") {
      const filtered = emailLogs.filter(
        (item) =>
          (item.email || "")
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          (item.username || "")
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          (item.firstname || "")
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          (item.lastname || "")
            .toLowerCase()
            .includes(searchValue.toLowerCase())
      );
      setFilteredLogs(filtered);
    } else {
      setFilteredLogs(emailLogs); // Reset to all email logs when search is cleared
    }
  }, [searchValue, emailLogs]);

  // Define columns for react-table
  const columns = useMemo(
    () => [
      {
        accessorKey: "email",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-envelope"></i> {t("Email")}
          </div>
        ),
        colName: t("Email"),
      },
      {
        accessorKey: "status",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-check-circle"></i> {t("Status")}
          </div>
        ),
        colName: t("Status"),
      },
      {
        accessorKey: "created_at",
        header: () => (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <i className="bi bi-calendar"></i> {t("CreatedAt")}
          </div>
        ),
        colName: t("CreatedAt"),
        cell: ({ getValue }) => {
          const date = new Date(getValue());
          return date.toLocaleString();
        },
      },
    ],
    [t]
  );

  // Initialize react-table instance
  const table = useReactTable({
    data: filteredLogs,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4 mb-4">
      {/* Search Section */}
      <div className="primaryBlueBox mb-4" id="pa">
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">{t("SearchEmailLogs")}</label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder={t("Searchbyusername")}
                aria-label="Search by name"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <button
                className="btn btn-outline-secondary btnSearchIcon"
                type="button"
              >
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <h3>{t("CampaignEmailLog")}</h3>

      {/* Loading Spinner */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <div
            className="spinner-border loader-api"
            role="status"
            style={{
              borderTopColor: "#6897CB",
              borderBottomColor: "#6897CB",
              borderLeftColor: "#6897CB",
              marginTop: "50px",
            }}
          />
        </div>
      ) : filteredLogs.length === 0 ? (
        <div className="text-center mt-4">{t("NoRecordsFound")}</div>
      ) : (
        <>
          {window.innerWidth < 768 ? (
            // Small screen stacked view
            <div className="stacked-table">
              {table.getRowModel().rows.map((row) => (
                <div
                  key={row.id}
                  className="stacked-row border p-2 mb-2 rounded"
                >
                  {row.getVisibleCells().map((cell) => (
                    <div key={cell.id} className="stacked-cell">
                      <strong>{cell.column.columnDef.colName}: </strong>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            // Desktop table view
            <table className="table table-bordered table-hover">
              <thead className="thead-dark">
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* Pagination */}
          <div className="navigationWrapper">
            <ul>
              {links.map((link, index) => (
                <li
                  key={index}
                  className={`${link.active ? "active" : ""} ${
                    link.url === null ? "disabled" : ""
                  }`}
                  onClick={
                    link.url !== null
                      ? () => fetchEmailLogs(link.url)
                      : undefined
                  }
                >
                  <div dangerouslySetInnerHTML={{ __html: link.label }} />
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default CampaignEmailLog;
